export function formatPhoneDisplay(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  const ddi = digits.startsWith('55') ? digits.slice(0, 2) : '55';
  const rest = digits.startsWith('55') ? digits.slice(2) : digits;
  if (rest.length === 11) {
    return `+${ddi} (${rest.slice(0, 2)}) ${rest.slice(2, 7)}-${rest.slice(7)}`;
  }
  if (rest.length === 10) {
    return `+${ddi} (${rest.slice(0, 2)}) ${rest.slice(2, 6)}-${rest.slice(6)}`;
  }
  return `+${digits}`;
}

export function parseEvolutionError(evoData: Record<string, unknown>, phoneSent: string): string {
  const responseMessages = evoData?.response as Record<string, unknown> | undefined;
  const messages = responseMessages?.message as Array<Record<string, unknown>> | undefined;

  if (messages && Array.isArray(messages) && messages.length > 0) {
    const first = messages[0];
    if (first.exists === false) {
      return `Numero ${formatPhoneDisplay(phoneSent)} nao tem WhatsApp (numero inexistente)`;
    }
    if (first.exists === true) {
      return `Numero ${formatPhoneDisplay(phoneSent)} existe no WhatsApp mas a mensagem foi rejeitada`;
    }
  }

  const responseMessageStr = typeof responseMessages?.message === 'string' ? responseMessages.message : '';
  const evoMessage = evoData?.message as string | undefined;
  const evoError = evoData?.error as string | undefined;

  const combined = [responseMessageStr, evoMessage, evoError]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  const notOnWhatsAppPatterns = [
    'not on whatsapp',
    'not registered',
    'nao existe',
    'nao esta no whatsapp',
    'number is not',
    'is not a whatsapp',
    'not a whatsapp',
    'invalid number',
    'recipient is not',
    'remotejid',
  ];

  if (notOnWhatsAppPatterns.some((p) => combined.includes(p))) {
    return `Numero ${formatPhoneDisplay(phoneSent)} nao tem WhatsApp (numero inexistente)`;
  }

  if (evoMessage && !/bad request/i.test(evoMessage)) return evoMessage;
  if (evoError && !/bad request/i.test(evoError)) return evoError;

  if (evoData?.status === 429) return 'Limite de envios da Evolution API atingido. Aguarde.';

  if (evoMessage?.includes?.('instance') || evoError?.includes?.('instance')) {
    return `Instancia WhatsApp indisponivel: ${evoMessage || evoError}`;
  }

  const status = evoData?.status;
  if (status === 400 || /bad request/i.test(`${evoMessage || ''} ${evoError || ''}`)) {
    return `Numero ${formatPhoneDisplay(phoneSent)} nao tem WhatsApp (erro 400 da Evolution)`;
  }

  return `Erro Evolution API (${status || '?'}): ${evoMessage || evoError || 'desconhecido'}`;
}